/* ==========================================================================
   KALEIDOSCOPE HAIR PRODUCTS — BACK TO SCHOOL 2026
   Shared behaviour for every bts-* section.
   Loaded once per page via {{ 'bts.js' | asset_url | script_tag }}
   Re-initialises on Shopify theme-editor section load/unload.
   ========================================================================== */
(function () {
  'use strict';

  var SUBJECTS = {
    kids: ['--bts-kids', '--bts-kids-2', '--bts-kids-tint'],
    baby: ['--bts-baby', '--bts-baby-2', '--bts-baby-tint'],
    curl: ['--bts-curl', '--bts-curl-2', '--bts-curl-tint']
  };

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: currency || 'USD',
        minimumFractionDigits: cents % 100 === 0 ? 0 : 2
      }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  /* ---------------- countdown --------------------------------------- */
  function initCountdown(scope) {
    scope.querySelectorAll('[data-bts-countdown]').forEach(function (el) {
      if (el.dataset.btsReady) return;
      el.dataset.btsReady = '1';

      var end = new Date(el.dataset.btsCountdown).getTime();
      var clock = el.querySelector('[data-bts-clock]');
      if (!clock || isNaN(end)) return;

      var tick = function () {
        var d = end - Date.now();
        if (d <= 0) { el.style.display = 'none'; clearInterval(el._btsTimer); return; }
        var day = Math.floor(d / 864e5),
            hr  = Math.floor(d % 864e5 / 36e5),
            min = Math.floor(d % 36e5 / 6e4),
            sec = Math.floor(d % 6e4 / 1e3);
        clock.textContent = (day > 0 ? day + 'd ' : '') + hr + 'h ' + min + 'm ' + sec + 's';
      };
      tick();
      el._btsTimer = setInterval(tick, 1000);
    });
  }

  /* ---------------- tab rail: recolour page accent ------------------ */
  function setSubject(key) {
    var vars = SUBJECTS[key];
    if (!vars) return;
    var cs = getComputedStyle(document.documentElement);
    document.documentElement.style.setProperty('--bts-accent',   cs.getPropertyValue(vars[0]).trim());
    document.documentElement.style.setProperty('--bts-accent-2', cs.getPropertyValue(vars[1]).trim());
    document.documentElement.style.setProperty('--bts-tint',     cs.getPropertyValue(vars[2]).trim());
    document.querySelectorAll('.bts-tab').forEach(function (t) {
      t.classList.toggle('is-active', t.dataset.tab === key);
    });
  }

  function initRail() {
    var rail = document.querySelector('[data-bts-rail]');
    var rows = document.querySelectorAll('.bts-sub[data-subject]');
    if (!rail || !rows.length) return;

    if (!rail.dataset.btsReady) {
      rail.dataset.btsReady = '1';
      rail.querySelectorAll('.bts-tab').forEach(function (t) {
        t.addEventListener('click', function () { setSubject(t.dataset.tab); });
      });
    }

    if (window._btsIO) window._btsIO.disconnect();
    if ('IntersectionObserver' in window) {
      window._btsIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) setSubject(e.target.dataset.subject);
        });
      }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });
      rows.forEach(function (r) { window._btsIO.observe(r); });
    }

    /* keep the rail parked under the sticky deal bar, whatever its height */
    var deal = document.querySelector('.bts-deal');
    if (deal) rail.style.top = deal.offsetHeight + 'px';
  }

  /* ---------------- FAQ --------------------------------------------- */
  function initFaq(scope) {
    scope.querySelectorAll('.bts-faq__q').forEach(function (btn) {
      if (btn.dataset.btsReady) return;
      btn.dataset.btsReady = '1';
      btn.setAttribute('aria-expanded', 'false');
      btn.addEventListener('click', function () {
        var item = btn.parentElement;
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* ---------------- shoppable strip: collection tabs ---------------- */
  function initStripTabs(scope) {
    scope.querySelectorAll('[data-bts-strip]').forEach(function (strip) {
      if (strip.dataset.btsReady) return;
      strip.dataset.btsReady = '1';
      var tabs   = strip.querySelectorAll('.bts-strip__tab');
      var panels = strip.querySelectorAll('.bts-strip__panel');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var key = tab.dataset.subject;
          tabs.forEach(function (t) {
            var on = t === tab;
            t.classList.toggle('is-active', on);
            t.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          panels.forEach(function (p) {
            p.classList.toggle('is-active', p.dataset.subject === key);
          });
        });
      });
    });
  }

  /* ---------------- tier meter -------------------------------------- */
  function paintMeter(totalCents) {
    document.querySelectorAll('[data-bts-meter]').forEach(function (meter) {
      var tiers = JSON.parse(meter.dataset.btsMeter);   // [{at:2500,off:20}, ...]
      var currency = meter.dataset.btsCurrency || 'USD';
      var fill  = meter.querySelector('[data-bts-fill]');
      var msg   = meter.querySelector('[data-bts-msg]');
      var now   = meter.querySelector('[data-bts-now]');
      var top   = tiers[tiers.length - 1].at;

      var earned = null, next = null;
      tiers.forEach(function (t) {
        if (totalCents >= t.at) earned = t;
        else if (!next) next = t;
      });

      if (fill) fill.style.width = Math.min(100, (totalCents / top) * 100) + '%';
      if (now) now.textContent = 'Cart ' + money(totalCents, currency);

      if (msg) {
        if (totalCents === 0 && meter.dataset.btsIdle) {
          msg.textContent = meter.dataset.btsIdle;
        } else if (!earned && next) {
          msg.innerHTML = 'Add <b>' + money(next.at - totalCents, currency) +
                          '</b> to unlock <b>' + next.off + '% off</b>';
        } else if (earned && next) {
          msg.innerHTML = '<b>' + earned.off + '% off</b> unlocked. Add <b>' +
                          money(next.at - totalCents, currency) + '</b> for <b>' +
                          next.off + '% off</b>';
        } else if (earned) {
          msg.innerHTML = 'Top tier unlocked — <b>' + earned.off + '% off</b>';
        }
      }

      meter.querySelectorAll('.bts-meter__mark').forEach(function (m) {
        m.classList.toggle('is-hit', totalCents >= parseInt(m.dataset.at, 10));
      });
    });
  }

  function refreshCart() {
    if (!document.querySelector('[data-bts-meter]')) return;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        paintMeter(cart.total_price);
        document.dispatchEvent(new CustomEvent('bts:cart', { detail: cart }));
      })
      .catch(function () { /* meter keeps its server-rendered state */ });
  }

  /* ---------------- quick add --------------------------------------- */
  function initQuickAdd(scope) {
    scope.querySelectorAll('[data-bts-add]').forEach(function (btn) {
      if (btn.dataset.btsReady) return;
      btn.dataset.btsReady = '1';

      btn.addEventListener('click', function () {
        var card = btn.closest('.bts-card');
        var sel  = card ? card.querySelector('[data-bts-variant]') : null;
        var id   = sel ? sel.value : btn.dataset.btsAdd;
        var original = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Adding…';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] })
        })
          .then(function (r) {
            if (!r.ok) throw new Error('add failed');
            return r.json();
          })
          .then(function () {
            btn.textContent = 'Added ✓';
            btn.classList.add('is-added');
            refreshCart();
            /* nudge the theme's own drawer/count to refresh — Wokiee & most
               OS2.0 themes listen for at least one of these */
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
            document.documentElement.dispatchEvent(
              new CustomEvent('cart:refresh', { bubbles: true }));
            setTimeout(function () {
              btn.textContent = original;
              btn.classList.remove('is-added');
              btn.disabled = false;
            }, 2200);
          })
          .catch(function () {
            btn.textContent = 'Sold out';
            setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 2200);
          });
      });
    });
  }

  /* ---------------- variant selects --------------------------------- */
  function initVariants(scope) {
    scope.querySelectorAll('[data-bts-variant]').forEach(function (sel) {
      if (sel.dataset.btsReady) return;
      sel.dataset.btsReady = '1';

      sel.addEventListener('change', function () {
        var card = sel.closest('.bts-card');
        if (!card) return;
        var opt   = sel.options[sel.selectedIndex];
        var price = card.querySelector('[data-bts-price]');
        var btn   = card.querySelector('[data-bts-add]');

        if (price && opt.dataset.price) {
          price.innerHTML = opt.dataset.compare
            ? '<del>' + opt.dataset.compare + '</del><ins>' + opt.dataset.price + '</ins>'
            : opt.dataset.price;
        }
        if (btn) {
          btn.dataset.btsAdd = opt.value;
          btn.disabled = opt.disabled;
        }
      });
    });
  }

  /* ---------------- boot -------------------------------------------- */
  function init(scope) {
    scope = scope || document;
    initCountdown(scope);
    initFaq(scope);
    initStripTabs(scope);
    initQuickAdd(scope);
    initVariants(scope);
    initRail();
    refreshCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  /* theme editor */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function () { initRail(); });

  window.BTS = { refreshCart: refreshCart, setSubject: setSubject, init: init };
})();
